<template>
  <van-popup v-model="modalVisible" class="popup-wrap">
    <div class="popup-box">
      <div class="popup-title" v-if="isAddManage">新建推广位</div>
      <div class="popup-title" v-else="!isAddManage">编辑推广位</div>
      <div class="padding-b-20">
        <div class="label-title">推广位名称</div>
        <div>
          <input type="text" v-model="app_name" placeholder="请输入不超过16个字符的名称">
        </div>
      </div>
      <div class="padding-b-20" v-if="!isAddManage">
        <div class="label-title">APP_SECRET</div>
        <div><span v-model="app_secret" class="app-secret">{{app_secret}}</span></div>
        <div class="btn-wrap padding-t-10">
          <div class="reset-btn" @click="reset()">重置</div>
          <div class="copy-btn" @click="copy()">复制</div>
        </div>
      </div>
      <div>
        <div class="label-title">备注</div>
        <div>
          <textarea placeholder="添加推广位备注，以便更好地区分" v-model="remark"></textarea>
        </div>
      </div>
      <div class="padding-t-30 btn-wrap">
        <div class="cancel-btn" @click="cancelAdd()">取消</div>
        <div class="sure-btn" @click="submitAddManage()">确定</div>
      </div>
    </div>
  </van-popup>
</template>

<script>
  import { createPromotion,editPromotion,appSecretReset } from '@/api/promotion'
  export default {
    name: "Add",
    data: function () {
      return {
        isAddManage: true,
        modalVisible: false,
        id: '',
        app_name:'',
        remark:'',
        app_key:'',
        app_secret:'',
        loading:false,
      }
    },
    mounted: function () {
      this.isAddManage = true
      this.modalVisible = false
    },
    methods: {
      init: function (isAddManage, row) {
        this.isAddManage = isAddManage
        this.modalVisible = true
        if(!isAddManage){
          this.id = row.id
          this.app_name = row.app_name
          this.remark = row.remark
          this.app_key = row.app_key
          this.app_secret = row.app_secret
        }else{
          this.id = '';
          this.app_name = '';
          this.remark = '';
          this.app_key = '';
          this.app_secret = '';
        }
      },
      cancelAdd() {
        this.modalVisible = false;
      },
      submitAddManage: function () {
        if(this.loading){
          return
        }
        if (this.app_name.length > 16) {
          this.$Message.error('推广位名称请填写16个字符以内')
          return
        }

        this.loading = true;
        const loadingMessage = this.$toast.loading({
          message: '保存中...',
          forbidClick: true,
          duration: 0,
        });
        if(this.isAddManage){
          createPromotion({
            app_name:this.app_name,
            remark:this.remark
          }).then(response => {
            // 手动清除 Toast
            this.$toast.clear();
            this.modalVisible = false;
            this.$toast.success(response.msg)
            this.loading = false
            this.$emit('refreshList');
          }).catch(error =>{
            // 手动清除 Toast
            this.$toast.clear();
            this.loading = false
            console.log(error)
          })
        }else{
          editPromotion({
            app_key:this.app_key,
            app_name:this.app_name,
            remark:this.remark
          }).then(response => {
            // 手动清除 Toast
            this.$toast.clear();
            this.modalVisible = false;
            this.$toast.success(response.msg)
            this.loading = false;
            this.$emit('refreshList');
          }).catch(error =>{
            // 手动清除 Toast
            this.$toast.clear();
            this.loading = false;
            console.log(error)
          })
        }
      },
      cancelSubmit: function () {
        this.modalVisible = false
      },
      copy: function () {
        var that = this
        this.$copyText(this.app_secret).then(function (e) {
          that.$toast.success('复制成功')
          console.log(e)
        }, function (e) {
          that.$toast.fail('复制失败,请升级浏览器版本！')
          console.log(e)
        })
      },
      reset:function () {
        if(this.loading){
          return
        }
        this.loading = true;
        const loadingMessage = this.$toast.loading({
          message: '重置中...',
          forbidClick: true,
          duration: 0
        });
        appSecretReset({
          app_key:this.app_key
        }).then(response => {
          // 手动清除 Toast
          this.$toast.clear();
          this.$toast.success(response.msg)
          this.app_secret = response.data.app_secret
          this.loading = false;
          this.$emit('refreshList');
        }).catch(error =>{
          // 手动清除 Toast
          this.$toast.clear();
          this.loading = false;
          console.log(error)
        })
      }
    },
  }
</script>

<style lang="less" scoped>
  .popup-wrap{
    width: calc(100% - 60px);
    max-height: calc(100% - 118px);
    border-radius: 8px;
    .popup-box{
      height: auto;
      padding: 20px;
      .popup-title{
        font-family: Alibaba-PuHuiTi-M;
        font-size: 18px;
        color: #222222;
        text-align: center;
        padding: 5px 0 25px 0;
      }
      .label-title{
        font-size: 14px;
        color: #666666;
        padding-bottom: 8px;
        .app-secret{
          padding-left: 20px;
        }
      }
      input{
        width: 100%;
        letter-spacing: 0;
        font-size: 14px;
        border-radius: 2px;
        background: #FAFAFA;
        height: 44px;
        padding: 0 12px;
      }
      textarea{
        width: 100%;
        resize: none;
        border-radius: 2px;
        background: #FAFAFA;
        height: 76px;
        padding: 11px 12px;
      }
      .btn-wrap{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        line-height: 35px;
        text-align: center;
        font-size: 16px;
        .reset-btn,.copy-btn{
          width: 130px;
          height: 35px;
          border-radius: 20px;
          color: #222222;
          border: 1px solid #EEEEEE;
        }
        // .copy-btn{
        //   width: 130px;
        //   height: 35px;
        //   border-radius: 20px;
        //   color: #222222;
        //   border: 1px solid #EEEEEE;
        // }
        .cancel-btn{
          width: 130px;
          height: 35px;
          background: #EEEEEE;
          border-radius: 20px;
          color: #666666;
        }
        .sure-btn{
          width: 130px;
          height: 35px;
          background: #FF8622;
          border-radius: 20px;
          color: #FFFFFF;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/h5/promotion/manage/modal/AddManage.vue